(function () {
    'use strict';

    var ChalkViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/chalk-view.html',
        controllerAs: 'vm',
        bindings: {
            imagebox: '=',
            imageart: '<',
            type: '<',
            width: '<',
            height:'<',
            propertyValue:'<',
            onChange: '&'
        },
        controller: ['$scope', 'ImageService', '$timeout', 'Qinius', 'QiniuToken', 'MessageService', 'UidService', 'FontXmlsManger', 'ClipArt', 'RecommendPics', '$stateParams', '$translate', '$filter','$http', 'ImgprocContours',
            function ($scope, ImageService, $timeout, Qinius, QiniuToken, MessageService, UidService, FontXmlsManger, ClipArt, RecommendPics, $stateParams, $translate, $filter, $http, ImgprocContours) {
                var vm = this;
                Qinius.getDomain({},function(res){
                    $scope.domain = 'https://' + res.domains[0] + '/';
                });
                QiniuToken.get('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"}, function (token) {
                    vm.token = token;
                });
                $scope.imagebox = vm.imagebox;
                $scope.imageart = vm.imageart;
                $scope.type = vm.type;
                $scope.width = Math.round(vm.width);
                $scope.height = Math.round(vm.height);
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // 移动设备判断关键字
                vm.isMobile = /iPad|iPhone|iPod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/.test(userAgent);
                vm.scale = 1;
                vm.windowWidth = vm.isMobile ? 343 : 530;
                if ($scope.width > $scope.height) {
                    vm.scale = vm.windowWidth / $scope.width;
                } else {
                    vm.scale = vm.windowWidth / $scope.height;
                }
                window.updateWhite = function ($event) {
                    $timeout(function () {
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            if(vm.isMobile){
                                MessageService.hint($translate.instant('chalk.message.invalidFormat', {fileType: file.type, type: $filter('serviceType')(vm.type)}));
                            }else{
                                MessageService.error($translate.instant('chalk.message.invalidFormat', {fileType: file.type, type: $filter('serviceType')(vm.type)}));
                            }
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = $translate.instant('chalk.loading.uploading', {type: $filter('serviceType')(vm.type)});
                        ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                            if($scope.type == 'uv' || $scope.type == 'fluore'){
                                //判断图片尺寸与原图尺寸是否一致
                                // var _img = new Image();
                                // _img.onload = function() {
                                    // var float = 5;
                                    // if (Math.abs(Math.round(_img.width) - $scope.width) > float || Math.abs(Math.round(_img.height) - $scope.height) > float) {
                                    //     vm.threeLoading = false;
                                    //     if (vm.isMobile) {
                                    //         vm.isError = _img.width + 'x' + _img.height + '≠' + $scope.width + 'x' + $scope.height;
                                    //     } else {
                                    //         MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                    //     }
                                    //     $scope.$apply();
                                    //     return;
                                    // }
                                    ImgprocContours.buildServiceImage({
                                        image: $scope.domain + data.key,
                                        "pageSize": {
                                            "width": PxTurnMm($scope.width),
                                            "height": PxTurnMm($scope.height)
                                        }
                                    },function(res){
                                        if(res.success){
                                            imageartAdd($http, res.data.serviceImage, null, function(imageart){
                                                imageart.geometry.x = 0;
                                                imageart.geometry.y = 0;
                                                imageart.geometry.width = $scope.width;
                                                imageart.geometry.height = $scope.height;
                                                if(vm.propertyValue){
                                                    imageart.spotColor = {
                                                        color: vm.propertyValue.color,
                                                        code: vm.propertyValue.spotColor,
                                                        name: vm.propertyValue.value,
                                                        growMethod: vm.propertyValue.epitaxy,
                                                        growValue: vm.propertyValue.epitaxyValue,
                                                        unit: vm.propertyValue.unit,
                                                        uuid: vm.propertyValue.uuid
                                                    };
                                                    imageart.serviceType = $scope.type;
                                                }
                                                $scope.imageart = imageart;
                                                vm.threeLoading = false;
                                            }, 1, true);
                                        }else{
                                            vm.threeLoading = false;
                                            MessageService.error($translate.instant('chalk.message.uploadFailed'));
                                        }
                                    },function(err){
                                        vm.threeLoading = false;
                                        MessageService.error($translate.instant('chalk.message.uploadFailed'));
                                    })
                                // };
                                // _img.onerror = function() {
                                //     vm.threeLoading = false;
                                //     MessageService.error($translate.instant('chalk.message.loadFailed', {type: $filter('serviceType')(vm.type)}));
                                //     $scope.$apply();
                                // };
                                // _img.src = $scope.domain + data.key;
                                return
                            }
                            $scope.imagebox.whiteInk = {
                                resource:{
                                    identifier:$scope.domain +data.key
                                },
                                growMethod: vm.propertyValue.epitaxy,
                                growValue: vm.propertyValue.epitaxyValue,
                                unit: vm.propertyValue.unit,
                                color: vm.propertyValue.spotColor,
                                colorValue: vm.propertyValue.color,
                            };
                            processImages($scope.imagebox.image.resource.identifier, $scope.imagebox.whiteInk.resource.identifier, function (res) {
                                var blob = base64ToBlob(res, file.type);
                                var _file = blobToFile(blob, file.name); 
                                ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                                    vm.threeLoading=false;
                                    $scope.imagebox.whiteInk2 = {
                                        resource:{
                                            identifier:$scope.domain +data.key
                                        },
                                        growMethod: vm.propertyValue.epitaxy,
                                        growValue: vm.propertyValue.epitaxyValue,
                                        unit: vm.propertyValue.unit,
                                        color: vm.propertyValue.spotColor,
                                        colorValue: vm.propertyValue.color,
                                    };
                                    $scope.$apply();
                                },function(err){
                                    vm.threeLoading=false;
                                    MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                    $scope.$apply();
                                })
                            }, function (error) {
                                vm.threeLoading=false;
                                if(vm.isMobile){
                                    vm.isError = error;
                                }else{
                                    MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                }
                                $scope.$apply();
                            })
                        },function(err){
                            vm.threeLoading=false;
                            MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                            $scope.$apply();
                        })
                    })
                };
                vm.threeLoading=false;
                vm.threeLoadingText = $translate.instant('chalk.loading.loading');
                $scope.setProcessImages = function(){
                    vm.threeLoading=true;
                    vm.threeLoadingText = $translate.instant('chalk.loading.generating', {type: $filter('serviceType')(vm.type)});
                    if($scope.imagebox.image && $scope.imagebox.image.resource && $scope.imagebox.image.resource.identifier){
                        processImages($scope.imagebox.image.resource.identifier,null,function(res){
                            var blob = base64ToBlob(res, 'image/' + $scope.imagebox.image.imageInfo.format);
                            var _file = blobToFile(blob); 
                            ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                                vm.threeLoading=false;
                                $scope.imagebox.whiteInk = null;
                                $scope.imagebox.whiteInk2 = {
                                    resource:{
                                        identifier:$scope.domain +data.key
                                    },
                                    growMethod: vm.propertyValue.epitaxy,
                                    growValue: vm.propertyValue.epitaxyValue,
                                    unit: vm.propertyValue.unit,
                                    color: vm.propertyValue.spotColor,
                                    colorValue: vm.propertyValue.color,
                                };
                                $scope.$apply();
                            },function(err){
                                vm.threeLoading=false;
                                MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                $scope.$apply();
                            })
                        },function(error){
                            vm.threeLoading=false;
                            MessageService.error(error);
                        })
                    }else{
                        vm.threeLoading=false;
                        MessageService.error($translate.instant('chalk.message.addImageFirst'));
                    }
                }
                $scope.imageartDelete = function () {
                    if($scope.imageart){
                        $scope.imageart = null;
                    }
                }
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    if($scope.type != 'white'){
                        if(!$scope.imageart || !$scope.imageart.resource || !$scope.imageart.resource.identifier){
                            MessageService.error($translate.instant('chalk.message.addImageFirst'));
                            return;
                        }
                        vm.onChange({text:$scope.imageart});
                    }else{
                        vm.onChange({text:$scope.imagebox});
                    }
                }
                $scope.goldFoil = function(color){
                    if(color){
                        return goldFoil(color)
                    }
                }
                $scope.sizeMm = function(){
                    if($scope.width && $scope.height){
                        return Math.round(PxTurnMm($scope.width)) + "x" + Math.round(PxTurnMm($scope.height)) + 'mm';
                    }
                }
                $scope.sizePx = function(){
                    if($scope.width && $scope.height){
                        return Math.round(PxTurnMm($scope.width) / 25.4 * 300) + "x" + Math.round(PxTurnMm($scope.height) / 25.4 * 300) + 'px';
                    }
                }
            }]
    };

    angular.module('editorApp')
        .component('chalkView', ChalkViewControl);

})();
